module.exports = __webpack_public_path__ + "images/missing_small_square-active@2x-e98270b89d59a1b93d02f8502ec70e46.png";